import React, { useState, useEffect } from 'react';
import { Rss, ExternalLink } from 'lucide-react';
import { rssFeedService } from '../services/api';

function RSSFeed() {
  const [rss, setRss] = useState({
    title: 'RSS Feed',
    description: 'آخرین مقالات و اخبار نشریه مجری را از طریق RSS دریافت کنید.',
    feedUrl: '/api/articles/rss',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRss = async () => {
      try {
        const response = await rssFeedService.get();
        if (response.data) {
          setRss({
            title: response.data.title || 'RSS Feed',
            description: response.data.description || '',
            feedUrl: response.data.feedUrl || '',
          });
        }
      } catch (error) {
        console.error('Error fetching RSS feed:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchRss();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">RSS Feed</h1>
          <p className="text-xl text-blue-100">دنبال کردن آخرین مقالات نشریه</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="bg-white rounded-xl shadow-md p-12 text-center">
          <Rss className="w-16 h-16 text-orange-500 mx-auto mb-6" />
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{rss.title}</h2>
          <p className="text-lg text-gray-600 mb-8">{rss.description}</p>

          {rss.feedUrl && (
            <a
              href={rss.feedUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-lg font-bold hover:from-orange-600 hover:to-orange-700 transition shadow-lg"
            >
              <ExternalLink size={20} />
              مشاهده فید RSS
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default RSSFeed;
